import { faCircle, faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import memoize from 'lodash-es/memoize';
import * as bzProps from 'mk/autogenerated/bzProps';
import {
    BZ2_EDIT_DESCRIPTION_HEADER,
    BZ2_EDIT_ESHOP_URL_HEADER,
    BZ2_EDIT_PHOTO_HEADER,
    BZ2_EDIT_PRICE_HEADER,
    BZ2_EDIT_SALARY_HEADER,
    BZ2_EDIT_SALARY_PER_HEADER,
    BZ2_EDIT_SALARY_PER_HOUR,
    BZ2_EDIT_SALARY_PER_MONTH,
    BZ2_EDIT_TITLE_HEADER,
    BZ2_FACET_CATEGORY,
    BZ2_FACET_COUNTRY,
    BZ2_FACET_COUNTY,
    BZ2_FACET_PLACE,
    BZ2_FACET_QUALITY2,
    BZ2_GET_PLAN,
    BZ2_HANDMADE_PRODUCT_HOVER,
    BZ2_NEW_PRODUCT_HOVER,
    BZ2_OLD_PRODUCT_HOVER,
    BZ2_QUALITY_YOU_HAVE_count_OF_max,
    BZ2_SERVICES_PRODUCT_HOVER,
    BZ2_SUGGEST_CATEGORY_CATEGORY,
    BZ2_UNLIMITED,
    BZ_IN_STOCK_LABEL,
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
    FORMS_DEFAULT_URL_FIELD_FORMAT_ERROR,
    HERE,
    NEW_STROLLER_ONLY_WITH_XML_url,
    NEW_STROLLER_ONLY_WITH_XML_MOBILE_url,
    PRODUCT_CREATE_EDIT_FORM_I_WANT_TO_PICK_CATEGORY_MANUALLY,
    PRODUCT_CREATE_EDIT_FORM_LOADING_SUGGESTIONS,
    PRODUCT_CREATE_EDIT_FORM_PHOTOS_FAILED,
    PRODUCT_CREATE_EDIT_FORM_UPLOAD_SCREEN_INFO_icon,
    PRODUCT_CREATE_EDIT_JOBS_CATEGORY_QUALITY,
    PRODUCT_CREATE_EDIT_JOBS_QUALITY_NEEDS_JOBS_CATEGORY,
    PRODUCT_CREATE_EDIT_MODEL_DO_NOT_MATCH_BRAND,
    PRODUCT_CREATE_EDIT_ONLY_ONE_VALUE_ALLOWED,
    PRODUCT_CREATE_EDIT_SERVICES_CATEGORY_QUALITY,
    PRODUCT_CREATE_EDIT_SERVICES_QUALITY_NEEDS_SERVICES_CATEGORY, SELECT_CATEGORY,
} from 'mk/autogenerated/translations/ProductCreateEditForm.9ec53335e76fee96ed7488d8b296d352'
import { FACET_NAMES, QUALITY_VALUES, SPECIAL_PRAM_MODELS } from 'mk/bazaar/common/enums';
import {
    getCategory,
    getLabel,
    getParentCategory,
    getPropertiesForCategories,
    isJobsCategory,
    isServicesCategory,
    list,
} from 'mk/bazaar/product/categories';
import { countiesSelectOptions, getPlacesSelectOptionsForCounty, localCountiesSelectOptions } from 'mk/geo';
import CategoriesList from 'mk2/apps/bazaar/components/CategoriesList';
import CategorySelectModal from 'mk2/apps/bazaar/components/CategorySelectModal';
import CategorySuggestionListItem from 'mk2/apps/bazaar/components/CategorySuggestionListItem';
import FacetSelect, { PropertyOption } from 'mk2/apps/bazaar/components/FacetSelect';
import FacetSelectModal, { MAX_HEIGHT } from 'mk2/apps/bazaar/components/FacetSelectModal';
import ProductFormAdding from 'mk2/apps/bazaar/components/ProductFormAdding';
import PropertyValue from 'mk2/apps/bazaar/components/PropertyValue';
import { isMultiselectProperty } from 'mk2/apps/bazaar/helpers';
import { validateDescription, validatePrice, validateTitle } from 'mk2/apps/bazaar/helpers/validators';
import { ProductPricePer, ProductQuality, QualityCounts } from 'mk2/apps/bazaar/schemas';
import { bazaarUrl } from 'mk2/apps/bazaar/urls';
import { planChoosePlanUrl, planGetProUrl } from 'mk2/apps/plan/urls';
import { CheckboxField } from 'mk2/components/forms/CheckboxField';
import { ClickableField } from 'mk2/components/forms/ClickableField';
import { InputField } from 'mk2/components/forms/InputField';
import { Option, SelectField } from 'mk2/components/forms/SelectField';
import { TextareaField } from 'mk2/components/forms/TextareaField';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Form } from 'mk2/components/Form';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { PlusProBadge } from 'mk2/components/PlusProBadge';
import { ProBadge } from 'mk2/components/ProBadge';
import { FormPageType } from 'mk2/constants/enums';
import { AutoDialogOpenType, PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import PhotoPreview from 'mk2/containers/PhotosUpload/PhotoPreview';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import { cacheLast } from 'mk2/helpers/cache';
import {
    FailedPhotoUpload,
    PendingPhotoUpload,
    PhotoUploadStatus,
    SuccessfulPhotoUpload,
} from 'mk2/helpers/form.reducers';
import { animateScrollTo } from 'mk2/helpers/scrolling';
import { url } from 'mk2/helpers/urls';
import { getFormState, AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { PhotoEntity, Plan, UserEntity } from 'mk2/schemas';
import { interpolate } from 'mk2/services/i18n';
import React, { FocusEvent } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, EventWithDataHandler, FormErrors, WrappedFieldInputProps } from 'redux-form';
import styles from './ProductCreateEditForm.mscss';

const emptyArray = [];
const pBrandAlwaysDisplayed = ['OTHER_BRAND'];
const pBrandModelAlwaysDisplayed = ['OTHER_BRAND_MODEL'];
const pManufacturerAlwaysDisplayed = ['OTHER_BRAND'];
const pFitsOnModelAlwaysDisplayed = ['OTHER_BRAND_MODEL', 'UNIVERSAL_BRAND_MODEL'];

export const PRODUCT_CREATE_EDIT_FORM_NAME = 'PRODUCT_CREATE_EDIT_FORM';

export interface Properties {
    quality: ProductQuality[];
    [prop: string]: Array<string | number>;
}

export interface ProductFormData {
    title: string;
    photos: Array<PhotoEntity & SuccessfulPhotoUpload>;
    properties: Properties;
    category: string;
    description: string;
    price: string;
    pricePer: string;
    eshopUrl: string;
    stock: boolean;
    location?: string; // ID of the county
    place?: string; // ID of the place
}

export interface Suggestion {
    category: string;
    text: string;
    p_type: string;
    p_sex: string;
}

export interface OwnProps {
    initialValues: ProductFormData;
    currentValues: ProductFormData;
    onTitleBlur?: EventWithDataHandler<FocusEvent<any>>;
    suggestions?: Suggestion[];
    suggestionsLoadingState?: LoadingState;
    qualityCounts?: QualityCounts;
    correctedFields?: string[];
    activePlan: Plan;
    isModeratorEdit?: boolean;
    isAdminEdit?: boolean;
    selectedProperty?: string;
    selectedCategory?: string;
    locationRequired?: boolean;
    submitButton: React.ReactNode;
    requestUser: UserEntity;
    requestUserPermissions: string[];

    onSave(values: ProductFormData);
    onSelectProperty(property: string);
    onSelectCategory(category: string);
}

interface DispatchProps {}

interface StateProps {
    title: string;
    mainPhoto: PhotoEntity;
    category: string;
    properties: Properties;
    location: string | null;
}

type Props = OwnProps & StateProps & DispatchProps;

interface Category {
    name: string;
    children?: Category[];
}

interface State {
    showAllCategories: boolean;
    openedModalFacet: string;
    modalPosition: {
        left: number;
        top: number;
    };
    openedModalCategory: boolean;
}

const qualityLabels = {
    [ProductQuality.OLD]: BZ2_OLD_PRODUCT_HOVER,
    [ProductQuality.NEW]: BZ2_NEW_PRODUCT_HOVER,
    [ProductQuality.HANDMADE]: BZ2_HANDMADE_PRODUCT_HOVER,
    [ProductQuality.SERVICES]: BZ2_SERVICES_PRODUCT_HOVER,
    // https://trello.com/c/cviGoLtm/6856-4d-docasne-vyhodit-pracu-z-bazara
    // [ProductQuality.JOBS]: BZ2_JOBS_PRODUCT_HOVER,
};

function getSalaryPerSelectOptions(): Option[] {
    return [
        { value: ProductPricePer.PER_MONTH.toString(), label: BZ2_EDIT_SALARY_PER_MONTH },
        { value: ProductPricePer.PER_HOUR.toString(), label: BZ2_EDIT_SALARY_PER_HOUR },
    ];
}

class ProductCreateEditForm extends React.Component<Props & MKReduxFormInjectedProps<ProductFormData, Props>, State> {
    public static validate(
        values: ProductFormData,
        { isAdminEdit, isModeratorEdit, locationRequired }: OwnProps,
    ): FormErrors<ProductFormData> {
        const errors: FormErrors<ProductFormData> = {};

        if (!values.title) {
            errors.title = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
        } else {
            const invalid = validateTitle(values.title);
            if (invalid !== null) {
                errors.title = invalid;
            }
        }

        if (!values.photos || values.photos.length === 0) {
            errors.photos = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
        } else if (values.photos.filter((photo) => photo.status === PhotoUploadStatus.SUCCESS).length === 0) {
            errors.photos = PRODUCT_CREATE_EDIT_FORM_PHOTOS_FAILED;
        }

        if (!values.price) {
            errors.price = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
        } else {
            const invalid = validatePrice(values.price);
            if (invalid !== null) {
                errors.price = invalid;
            }
        }

        if (values.description) {
            const invalid = validateDescription(values.description);
            if (invalid !== null) {
                errors.description = invalid;
            }
        }

        if (
            values.eshopUrl &&
            !/^[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,10}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/gi.test(
                values.eshopUrl,
            )
        ) {
            errors.eshopUrl = FORMS_DEFAULT_URL_FIELD_FORMAT_ERROR;
        }

        if (!values.category) {
            errors.category = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
        } else {
            const propertiesForCategory = getPropertiesForCategories([values.category]);
            if (!isModeratorEdit && !isAdminEdit && !values.properties.quality.length) {
                (errors as any).properties = errors.properties || {};
                (errors.properties as any).quality = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
            }

            propertiesForCategory.forEach((property) => {
                if (
                    !isModeratorEdit &&
                    !isAdminEdit &&
                    (!values.properties[property] || values.properties[property].length === 0)
                ) {
                    (errors as any).properties = errors.properties || {};
                    (errors.properties as any)[property] = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
                }
            });

            propertiesForCategory.forEach((property) => {
                if (
                    !isModeratorEdit &&
                    !isAdminEdit &&
                    !isMultiselectProperty(values.properties.quality[0], property) &&
                    values.properties[property] &&
                    values.properties[property].length > 1
                ) {
                    (errors as any).properties = errors.properties || {};
                    (errors.properties as any)[property] = PRODUCT_CREATE_EDIT_ONLY_ONE_VALUE_ALLOWED;
                }
            });
        }

        const isJobsCat = isJobsCategory(values.category);
        const isWorkAbroad = values.category === 'work_abroad';

        if (values.properties.quality.length) {
            const isServicesCat = isServicesCategory(values.category);
            const isServicesQual = values.properties.quality.includes(ProductQuality.SERVICES);
            if (isServicesCat && !isServicesQual) {
                (errors as any).properties = errors.properties || {};
                (errors.properties as any).quality = PRODUCT_CREATE_EDIT_SERVICES_CATEGORY_QUALITY;
            } else if (!isServicesCat && isServicesQual) {
                errors.category = PRODUCT_CREATE_EDIT_SERVICES_QUALITY_NEEDS_SERVICES_CATEGORY;
            }

            const isJobsQual = values.properties.quality.includes(ProductQuality.JOBS);
            if (isJobsCat && !isJobsQual) {
                (errors as any).properties = errors.properties || {};
                (errors.properties as any).quality = PRODUCT_CREATE_EDIT_JOBS_CATEGORY_QUALITY;
            } else if (!isJobsCat && isJobsQual) {
                errors.category = PRODUCT_CREATE_EDIT_JOBS_QUALITY_NEEDS_JOBS_CATEGORY;
            }
        }

        if ((locationRequired || isJobsCat) && !isWorkAbroad && !values.location) {
            errors.location = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
        }

        if ((locationRequired || isJobsCat) && !values.place) {
            errors.place = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
        }

        // checking p_brand_model
        if (
            values.properties.p_brand?.length &&
            values.properties.p_brand_model?.length &&
            !(values.properties.p_brand_model[0] as string).startsWith(
                SPECIAL_PRAM_MODELS.includes(values.properties.p_brand[0] as string)
                    ? (values.properties.p_brand[0] as string)
                    : (values.properties.p_brand[0] as string) + ' ',
            ) &&
            values.properties.p_brand_model[0] !== 'OTHER_BRAND_MODEL'
        ) {
            (errors as any).properties = errors.properties || {};
            (errors.properties as any).p_brand_model = PRODUCT_CREATE_EDIT_MODEL_DO_NOT_MATCH_BRAND;
        }

        // checking p_brand_models
        if (
            values.properties.p_brand?.length &&
            values.properties.p_brand_models?.length &&
            values.properties.p_brand_models.some(
                (model) =>
                    !(model as string).startsWith(
                        SPECIAL_PRAM_MODELS.includes(values.properties.p_brand[0] as string)
                            ? (values.properties.p_brand[0] as string)
                            : (values.properties.p_brand[0] as string) + ' ',
                    ) &&
                    model !== 'OTHER_BRAND_MODEL' &&
                    model !== 'UNIVERSAL_BRAND_MODEL',
            )
        ) {
            (errors as any).properties = errors.properties || {};
            (errors.properties as any).p_brand_models = PRODUCT_CREATE_EDIT_MODEL_DO_NOT_MATCH_BRAND;
        }

        return errors;
    }

    public state: State = {
        showAllCategories: false,
        openedModalFacet: null,
        modalPosition: null,
        openedModalCategory: false,
    };

    private cachePlacesSelectOption = cacheLast(true);
    private cacheSalaryPerSelectOption = cacheLast(true);
    private cacheFacetOptions = cacheLast(true);

    private onGoToPropertySelect = memoize((property: string) => () => {
        const { onOpenFormPage, onSelectProperty, isMobile } = this.props;
        if (this.isPropertyEditDisabled(property)) {
            // Cannot be edited
            return;
        }

        if (isMobile) {
            onSelectProperty(property);
            onOpenFormPage(FormPageType.SelectBazaarProperty);
        } else {
            // Detect position where to render modal
            const el = document.getElementById(`properties.${property}`);
            const rect = el.getBoundingClientRect();
            let top = rect.top;
            // Detect modal window overflow
            if (rect.top + MAX_HEIGHT > window.innerHeight) {
                const scrollTo = window.scrollY + rect.top + MAX_HEIGHT - window.innerHeight;
                top = window.innerHeight - MAX_HEIGHT;
                animateScrollTo(scrollTo, 100, () => {
                    this.setState({
                        openedModalFacet: property,
                        modalPosition: { top, left: rect.left - 10 /* 10px left margin */ },
                        openedModalCategory: false,
                    });
                });
            } else {
                this.setState({
                    openedModalFacet: property,
                    modalPosition: { top, left: rect.left - 10 /* 10px left margin */ },
                    openedModalCategory: false,
                });
            }
        }
    });

    public render() {
        const { currentFormPage } = this.props;

        if (currentFormPage === FormPageType.SelectBazaarCategory) {
            return this.renderSelectCategory();
        } else if (currentFormPage === FormPageType.Main) {
            return this.renderMain();
        } else if (currentFormPage === FormPageType.SelectBazaarProperty) {
            return this.renderSelectProperty();
        }
    }

    private onSuggestionClick = (suggestion: Suggestion) => {
        const { change, onCloseFormPage, isMobile } = this.props;
        const propertiesForCategory = getPropertiesForCategories([suggestion.category]);
        change('category', suggestion.category);
        if (propertiesForCategory.includes('p_type') && suggestion.p_type) {
            change('properties.p_type', [suggestion.p_type]);
        }
        if (propertiesForCategory.includes('p_sex') && suggestion.p_sex) {
            change('properties.p_sex', [suggestion.p_sex]);
        }
        if (isMobile) {
            onCloseFormPage();
        } else {
            this.onModalClose();
        }
    };

    private onPropertyClick = (property: string, value: string) => {
        const { change, onCloseFormPage, properties, category, isMobile } = this.props;
        const propertiesForCategory = category ? getPropertiesForCategories([category]) : null;

        const onClose = () => {
            if (isMobile) {
                onCloseFormPage();
            } else {
                this.onModalClose();
            }
        };

        // Special handling for quality change
        if (property === 'quality') {
            const newProperties = Object.keys(properties).reduce<Properties>(
                (acc, cur) => {

                    if (cur === 'quality') {
                        // Skip quality
                        return acc;
                    }

                    acc[cur] = !isMultiselectProperty(value as ProductQuality, cur)
                        ? [properties[cur][0]]
                        : properties[cur];
                    return acc;
                },
                {
                    quality: [value as ProductQuality],
                },
            );

            if (value === ProductQuality.HANDMADE && propertiesForCategory.includes('p_brand')) {
                newProperties.p_brand = ['HANDMADE'];
            }

            change('properties', newProperties);
            onClose();
            return;
        }

        // If quality is set to handmade - always set category to HANDMADE
        if (property === 'p_brand' && properties.quality[0] === ProductQuality.HANDMADE) {
            change(`properties.${property}`, ['HANDMADE']);
            onClose();
            return;
        }

        if (
            property === 'p_brand' &&
            properties.p_brand_model?.length &&
            !(properties.p_brand_model[0] as string).startsWith(value + ' ')
        ) {
            change('properties', {
                ...properties,
                p_brand: [value],
                p_brand_model: [],
            });
            onClose();
            return;
        }

        if (property === 'p_brand_model') {
            const categoryProperties = bzProps[category];
            const foundBrand =
                properties.p_brand?.length && !value.startsWith((properties.p_brand[0] as string) + ' ')
                    ? properties.p_brand
                    : categoryProperties.p_brand.find((p) => value.startsWith(
                        SPECIAL_PRAM_MODELS.includes(p[0])
                            ? p[0]
                            : p[0] + ' ',
                        ));
            change('properties', {
                ...properties,
                p_brand_model: [value],
                p_brand: foundBrand ? [foundBrand[0]] : [],
            });
            onClose();
            return;
        }

        if (isMultiselectProperty(properties.quality && properties.quality[0], property)) {
            const newValue = !properties[property]
                ? [value]
                : properties[property].includes(value)
                ? properties[property].filter((v) => v !== value)
                : [...properties[property], value];
            change(`properties.${property}`, newValue);
        } else {
            change(`properties.${property}`, [value]);
            onClose();
        }
    };

    private isServicesOverlimit = (): boolean => {
        const { activePlan, isAdminEdit, isModeratorEdit, qualityCounts } = this.props;
        const myServicesCount = qualityCounts?.services || 0;
        const maxServices = QUALITY_VALUES.services[`max${activePlan === Plan.FREE ? '' : '_' + activePlan}`];
        return !isAdminEdit && !isModeratorEdit && maxServices >= 0 && myServicesCount >= maxServices;
    };

    private isJobsOverlimit = (): boolean => {
        const { activePlan, isAdminEdit, isModeratorEdit, qualityCounts } = this.props;
        const myJobsCount = qualityCounts?.jobs || 0;
        const maxJobs = QUALITY_VALUES.jobs[`max${activePlan === Plan.FREE ? '' : '_' + activePlan}`];
        return !isAdminEdit && !isModeratorEdit && maxJobs >= 0 && myJobsCount >= maxJobs;
    };

    private renderMain() {
        const {
            handleSubmit,
            category,
            onTitleBlur,
            activePlan,
            isModeratorEdit,
            properties,
            location,
            locationRequired,
            submitButton,
            isMobile,
            suggestionsLoadingState,
            suggestions,
        } = this.props;
        const { options, hasFiltering, isSelected } = this.getPropsForFacetSelect();
        const { openedModalFacet, modalPosition, openedModalCategory } = this.state;

        const quality = properties.quality && properties.quality.length > 0 && properties.quality[0];
        let propertiesForCategory = category ? getPropertiesForCategories([category]) : null;
        // For Handmade quality, p_brand cannot be changed -> it is always filled with ['HANDMADE']
        if (properties.quality?.length && properties.quality[0] === ProductQuality.HANDMADE && propertiesForCategory) {
            propertiesForCategory = propertiesForCategory.filter((p) => p !== 'p_brand');
        }

        const isJobsCat = category && isJobsCategory(category);
        const isWorkAbroad = category === 'work_abroad';

        const placesSelectOptions = this.cachePlacesSelectOption(
            () => getPlacesSelectOptionsForCounty(location),
            location,
        );

        const salaryPerSelectOptions = this.cacheSalaryPerSelectOption(() => getSalaryPerSelectOptions());

        const servicesOverlimit = this.isServicesOverlimit();
        const jobsOverlimit = this.isJobsOverlimit();

        return (
            <Form className={styles.ProductCreateEditForm__main} onSubmit={handleSubmit}>
                <InputField
                    name="title"
                    type="text"
                    label={BZ2_EDIT_TITLE_HEADER}
                    onBlur={onTitleBlur}
                    hasLargeFont
                    maxLength={50}
                />
                <ClickableField
                    name="photos"
                    label={BZ2_EDIT_PHOTO_HEADER}
                    onClick={this.onGoToPhotos}
                    ValueComponent={this.renderPhotos}
                />
                <ClickableField
                    name="category"
                    label={BZ2_FACET_CATEGORY}
                    onClick={this.onGoToSelectCategory}
                    ValueComponent={this.renderCategory}
                    disabled={this.isPropertyEditDisabled('category')}
                />
                {category && (
                    <>
                        <ClickableField
                            name="properties.quality"
                            label={BZ2_FACET_QUALITY2}
                            onClick={this.onGoToPropertySelect('quality')}
                            ValueComponent={this.renderQuality}
                            disabled={this.isPropertyEditDisabled('quality')}
                        />
                        {propertiesForCategory.map((property) => (
                            <ClickableField
                                key={property}
                                name={`properties.${property}`}
                                label={
                                    FACET_NAMES[`BZ2_FACET_${property.toUpperCase()}`] ||
                                    `BZ2_FACET_${property.toUpperCase()}`
                                }
                                onClick={this.onGoToPropertySelect(property)}
                                ValueComponent={this.renderProperty}
                                disabled={
                                    this.isPropertyEditDisabled(property) ||
                                    (property === 'p_brand' && properties.quality[0] === ProductQuality.HANDMADE)
                                }
                            />
                        ))}
                    </>
                )}
                {properties.quality &&
                    properties.quality.length > 0 &&
                    !['old', 'services', 'jobs'].includes(properties.quality[0]) && (
                        <CheckboxField label={BZ_IN_STOCK_LABEL} name="stock" />
                    )}
                <TextareaField
                    name="description"
                    label={BZ2_EDIT_DESCRIPTION_HEADER}
                    rows={10}
                    maxRows={5}
                    disabled={isModeratorEdit}
                    maxLength={3000}
                />
                {activePlan === Plan.PRO && ![ProductQuality.SERVICES, ProductQuality.JOBS].includes(quality) && (
                    <InputField
                        name="eshopUrl"
                        type="url"
                        label={BZ2_EDIT_ESHOP_URL_HEADER}
                        disabled={isModeratorEdit}
                    />
                )}
                <InputField
                    name="price"
                    type="text"
                    label={isJobsCat ? BZ2_EDIT_SALARY_HEADER : BZ2_EDIT_PRICE_HEADER}
                    disabled={isModeratorEdit}
                />
                {isJobsCat && (
                    <SelectField name="pricePer" label={BZ2_EDIT_SALARY_PER_HEADER} options={salaryPerSelectOptions} />
                )}
                {(locationRequired || isJobsCat) && (
                    <>
                        {!isWorkAbroad && (
                            <SelectField
                                name="location"
                                label={BZ2_FACET_COUNTY}
                                options={isJobsCat ? localCountiesSelectOptions : countiesSelectOptions}
                                onChange={this.onLocationChange}
                            />
                        )}
                        {(((locationRequired || isJobsCat) && location !== '') || isWorkAbroad) && (
                            <SelectField
                                name="place"
                                label={location === '0' || isWorkAbroad ? BZ2_FACET_COUNTRY : BZ2_FACET_PLACE}
                                options={placesSelectOptions}
                            />
                        )}
                    </>
                )}
                <div className={styles.ProductCreateEditForm__submit}>{submitButton}</div>
                {!isMobile && (
                    <>
                        <FacetSelectModal
                            hasFiltering={hasFiltering}
                            options={options}
                            label={
                                openedModalFacet === 'quality'
                                    ? BZ2_FACET_QUALITY2
                                    : openedModalFacet
                                    ? FACET_NAMES[`BZ2_FACET_${openedModalFacet.toUpperCase()}`] ||
                                      `BZ2_FACET_${openedModalFacet.toUpperCase()}`
                                    : ''
                            }
                            property={openedModalFacet}
                            isSelected={isSelected}
                            onItemClick={this.onPropertyClick}
                            show={Boolean(openedModalFacet)}
                            onClose={this.onModalClose}
                            left={modalPosition?.left}
                            top={modalPosition?.top}
                            multiple={isMultiselectProperty(
                                properties.quality && properties.quality[0],
                                openedModalFacet,
                            )}
                            alwaysDisplayed={
                                openedModalFacet === 'p_brand'
                                    ? pBrandAlwaysDisplayed
                                    : openedModalFacet === 'p_brand_model' || openedModalFacet === 'p_brand_models'
                                    ? pBrandModelAlwaysDisplayed
                                    : openedModalFacet === 'p_manufacturer'
                                    ? pManufacturerAlwaysDisplayed
                                    : openedModalFacet === 'p_fits_on_model'
                                    ? pFitsOnModelAlwaysDisplayed
                                    : undefined
                            }
                        />
                        <CategorySelectModal
                            show={openedModalCategory}
                            left={modalPosition?.left}
                            top={modalPosition?.top}
                            onClose={this.onModalClose}
                            selected={category}
                            servicesOverlimit={servicesOverlimit}
                            jobsOverlimit={jobsOverlimit}
                            isLoadingSuggestions={!category && suggestionsLoadingState === LoadingState.LOADING}
                            suggestions={suggestions}
                            onSuggestionClick={this.onSuggestionClick}
                            onCategoryClick={this.onCategoryClick}
                        />
                    </>
                )}

            </Form>
        );
    }

    private decorateCategories = (
        categories: Category[],
        servicesOverlimit: boolean,
        jobsOverlimit: boolean,
    ): Category[] => {
        return categories.map((cat) => {
            const isOverlimitServices = servicesOverlimit && isServicesCategory(cat.name);
            const isOverlimitJobs = jobsOverlimit && isJobsCategory(cat.name);
            const isOverlimit = isOverlimitServices || isOverlimitJobs;
            return {
                name: cat.name,
                children: cat.children ? this.decorateCategories(cat.children, servicesOverlimit, jobsOverlimit) : null,
                disabled: isOverlimit,
                needsPlusPro: isOverlimitServices,
                needsPro: isOverlimitJobs,
            };
        });
    };

    private renderSelectCategory() {
        const { title, mainPhoto, category, suggestions, selectedCategory, suggestionsLoadingState } = this.props;
        const { showAllCategories } = this.state;

        const servicesOverlimit = this.isServicesOverlimit();
        const jobsOverlimit = this.isJobsOverlimit();
        const selCategory: Category = getCategory(selectedCategory);
        const categories: Category[] = this.decorateCategories(
            selCategory ? selCategory.children : list(),
            servicesOverlimit,
            jobsOverlimit,
        );
        const showSuggestionsLoading =
            !category && !showAllCategories && suggestionsLoadingState === LoadingState.LOADING;
        const showSuggestions = !category && suggestions && suggestions.length > 0 && !showAllCategories;

        return (
            <div className={styles.ProductCreateEditForm__selectCategory}>
                <ProductFormAdding
                    className={styles.ProductCreateEditForm__selectCategory__adding}
                    title={title}
                    category={category}
                    mainPhoto={mainPhoto}
                />

                {selectedCategory ? (
                    <div className={styles.ProductCreateEditForm__selectCategory__headline}>
                        <span className={styles.ProductCreateEditForm__selectCategory__headline__text}>
                            {getLabel(selectedCategory)}
                        </span>
                    </div>
                ) : showSuggestions ? (
                    <>
                        <div className={styles.ProductCreateEditForm__selectCategory__headline}>
                            <span className={styles.ProductCreateEditForm__selectCategory__headline__text}>
                                {BZ2_SUGGEST_CATEGORY_CATEGORY}
                            </span>
                        </div>
                        <div className={styles.ProductCreateEditForm__selectCategory__categories}>
                            {suggestions.map((suggestion, index) => (
                                <CategorySuggestionListItem
                                    key={suggestion.category}
                                    isLast={index + 1 === suggestions.length}
                                    suggestion={suggestion}
                                    onClick={this.onSuggestionClick}
                                />
                            ))}
                        </div>
                        <div className={styles.ProductCreateEditForm__selectCategory__showAll}>
                            <Btn
                                type={BtnType.Link}
                                label={PRODUCT_CREATE_EDIT_FORM_I_WANT_TO_PICK_CATEGORY_MANUALLY}
                                onClick={this.onShowAllCategories}
                            />
                        </div>
                    </>
                ) : showSuggestionsLoading ? (
                    <div className={styles.ProductCreateEditForm__selectCategory__loadingSuggestions}>
                        {PRODUCT_CREATE_EDIT_FORM_LOADING_SUGGESTIONS}
                    </div>
                ) : (
                    <div className={styles.ProductCreateEditForm__selectCategory__headline}>
                        <span className={styles.ProductCreateEditForm__selectCategory__headline__text}>
                            {SELECT_CATEGORY}
                        </span>
                    </div>
                )}

                {!showSuggestions && !showSuggestionsLoading && (
                    <CategoriesList
                        className={styles.ProductCreateEditForm__selectCategory__categories}
                        categories={categories}
                        showIcons={!selectedCategory}
                        onClick={this.onCategoryClick}
                        selected={category}
                    />
                )}
            </div>
        );
    }

    private renderSelectProperty() {
        const { title, mainPhoto, category, selectedProperty, isMobile } = this.props;
        const { options, hasFiltering, isSelected } = this.getPropsForFacetSelect();
        return (
            <div className={styles.ProductCreateEditForm__selectProperty}>
                <ProductFormAdding
                    className={styles.ProductCreateEditForm__selectProperty__adding}
                    title={title}
                    category={category}
                    mainPhoto={mainPhoto}
                />
                <FacetSelect
                    hasFiltering={hasFiltering}
                    options={options}
                    isMobile={isMobile}
                    label={
                        selectedProperty === 'quality'
                            ? BZ2_FACET_QUALITY2
                            : (
                                FACET_NAMES[`BZ2_FACET_${selectedProperty.toUpperCase()}`] ||
                                `BZ2_FACET_${selectedProperty.toUpperCase()}`
                            )
                    }
                    property={selectedProperty}
                    isSelected={isSelected}
                    onItemClick={this.onPropertyClick}
                    alwaysDisplayed={selectedProperty === 'p_brand' ? pBrandAlwaysDisplayed : undefined}
                />
            </div>
        );
    }

    private getPropsForFacetSelect = (): {
        options: PropertyOption[];
        hasFiltering: boolean;
        isSelected(opt: PropertyOption): boolean;
    } => {
        const { properties, category, activePlan, qualityCounts, isModeratorEdit, isAdminEdit, isMobile } = this.props;
        const categoryProperties = bzProps[category];
        // On mobile we are using props.selectedProperty from redux and FormPages
        // On desktop we are using local state because facets are modal designed
        const selectedProperty = this.props.selectedProperty || this.state.openedModalFacet;

        let options: PropertyOption[] = emptyArray;
        let hasFiltering = false;
        if (selectedProperty === 'quality') {
            const availableQualities =
                activePlan === Plan.PRO
                    ? [
                        ProductQuality.NEW,
                        ProductQuality.HANDMADE,
                        ProductQuality.OLD,
                        ProductQuality.SERVICES,
                        // https://trello.com/c/cviGoLtm/6856-4d-docasne-vyhodit-pracu-z-bazara
                        // ProductQuality.JOBS,
                    ]
                    : [
                        ProductQuality.OLD,
                        ProductQuality.HANDMADE,
                        ProductQuality.NEW,
                        ProductQuality.SERVICES,
                        // https://trello.com/c/cviGoLtm/6856-4d-docasne-vyhodit-pracu-z-bazara
                        // ProductQuality.JOBS,
                    ];

            options = availableQualities.map((quality) => {
                const myCount = qualityCounts?.[quality] || 0;
                const max = QUALITY_VALUES[quality][`max${activePlan === Plan.FREE ? '' : '_' + activePlan}`];
                const overlimit = !isAdminEdit && !isModeratorEdit && max >= 0 && myCount >= max;
                return {
                    label: (
                        <span className={styles.ProductCreateEditForm__quality}>
                            <span
                                className={cx(
                                    styles.ProductCreateEditForm__quality__label,
                                    overlimit && styles['ProductCreateEditForm__quality__label--disabled'],
                                )}
                            >
                                {qualityLabels[quality]}{' '}
                                <span className={styles.ProductCreateEditForm__quality__limit}>
                                    {max > 0
                                        ? interpolate(BZ2_QUALITY_YOU_HAVE_count_OF_max, { count: myCount, max })
                                        : max === -1
                                        ? `(${BZ2_UNLIMITED})`
                                        : ''}
                                </span>
                            </span>
                            {overlimit && (
                                <span className={styles.ProductCreateEditForm__quality__ad}>
                                    {activePlan === Plan.PRO || quality === 'new' ? (
                                        <Link to={url(planGetProUrl, {}, {src: 'editProduct'})} target="_blank">
                                            {BZ2_GET_PLAN}&nbsp;
                                            <ProBadge/>
                                        </Link>
                                    ) : (
                                        <Link to={url(planChoosePlanUrl, {}, {src: 'editProduct'})} target="_blank">
                                            {BZ2_GET_PLAN}&nbsp;
                                            <PlusProBadge/>
                                        </Link>
                                    )}
                                </span>
                                )}
                        </span>
                        ),
                    filterValue: qualityLabels[quality],
                    value: quality,
                    disabled: overlimit,
                };
            });

        } else if (
            (selectedProperty === 'p_brand_model' || selectedProperty === 'p_brand_models') &&
            properties.p_brand?.length
        ) {
            options = this.cacheFacetOptions(() => {
                return categoryProperties[selectedProperty]
                    .filter(
                        (p) =>
                            p[1].startsWith(SPECIAL_PRAM_MODELS.includes(properties.p_brand[0].toString())
                                ? properties.p_brand[0]
                                : properties.p_brand[0] + ' ',
                            ) ||
                            p[0] === 'OTHER_BRAND_MODEL' ||
                            p[0] === 'UNIVERSAL_BRAND_MODEL',
                    )
                    .map<PropertyOption>((p) => ({
                        label: p[1],
                        value: p[0],
                        filterValue: p[1],
                    }));
            }, [categoryProperties, selectedProperty, properties.p_brand[0]]);
            hasFiltering = categoryProperties[selectedProperty].length > 10;
        } else if (selectedProperty) {
            options = this.cacheFacetOptions(() => {
                return categoryProperties[selectedProperty].map((p) => ({
                    label: p[1],
                    value: p[0],
                    filterValue: p[1],
                }));
            }, [categoryProperties, selectedProperty]);
            hasFiltering = categoryProperties[selectedProperty].length > 10;
        }

        const isSelected = (option: PropertyOption) =>
            properties[selectedProperty] ? properties[selectedProperty].includes(option.value) : false;

        return {
            options,
            hasFiltering,
            isSelected,
        };
    };

    private onModalClose = () => {
        this.setState({
            openedModalFacet: null,
            modalPosition: null,
            openedModalCategory: false,
        });
    };

    private onShowAllCategories = () => {
        this.setState({ showAllCategories: true });
    };

    private onGoToSelectCategory = () => {
        const { onOpenFormPage, isMobile } = this.props;
        if (isMobile) {
            onOpenFormPage(FormPageType.SelectBazaarCategory);
        } else {
            // Detect position where to render modal
            const el = document.getElementById('category');
            const rect = el.getBoundingClientRect();
            let top = rect.top;
            // Detect modal window overflow
            if (rect.top + MAX_HEIGHT > window.innerHeight) {
                const scrollTo = window.scrollY + rect.top + MAX_HEIGHT - window.innerHeight;
                top = window.innerHeight - MAX_HEIGHT;
                animateScrollTo(scrollTo, 100, () => {
                    this.setState({
                        openedModalCategory: true,
                        modalPosition: { top, left: rect.left - 10 /* 10px left margin */ },
                        openedModalFacet: null,
                    });
                });
            } else {
                this.setState({
                    openedModalCategory: true,
                    modalPosition: { top, left: rect.left - 10 /* 10px left margin */ },
                    openedModalFacet: null,
                });
            }
        }
    };

    private onGoToPhotos = () => {
        const { onOpenFormPage } = this.props;
        onOpenFormPage(FormPageType.Photos);
    };

    private onCategoryClick = (category: Category) => {
        if (category.children && category.children.length) {
            const { onSelectCategory } = this.props;
            onSelectCategory(category.name);
        } else {
            const { change, onCloseFormPage, properties, category: prevCategory, isMobile } = this.props;
            change('category', category.name);
            // Remove all properties which do not belongs to this new category
            const newProperties = Object.keys(properties).reduce<Properties>(
                (acc, cur) => {
                    if (cur === 'quality') {
                        // Skip quality
                        return acc;
                    }

                    let values = !isMultiselectProperty(properties.quality[0], cur)
                        ? [properties[cur][0]]
                        : properties[cur];

                    if (category.name === 'prams_accessories') {
                        // https://trello.com/c/WbMVnInS
                        // We want to preserve p_brand and p_brand_model when
                        // changing to `prams_accessories` category
                        if (cur === 'p_brand') {
                            cur = 'p_manufacturer';
                        } else if (cur === 'p_brand_model') {
                            cur = 'p_fits_on_model';
                        }
                    } else if (prevCategory === 'prams_accessories') {
                        // https://trello.com/c/WbMVnInS
                        // We want to preserve p_manufacturer and p_fits_on_model when
                        // changing from `prams_accessories` category
                        if (cur === 'p_manufacturer' && bzProps[category.name].p_brand) {
                            cur = 'p_brand';
                        } else if (cur === 'p_fits_on_model' && bzProps[category.name].p_brand_model) {
                            cur = 'p_brand_model';
                            values = [values[0]];
                        }
                    }

                    // Filter not allowed values
                    if (!bzProps[category.name][cur]) {
                        return acc;
                    }

                    const allowed = bzProps[category.name][cur].map((x) => x[0]);
                    acc[cur] = values.filter((x) => allowed.includes(x));

                    return acc;
                },
                {
                    quality: properties.quality,
                },
            );

            if (bzProps[category.name].p_brand && properties.quality[0] === ProductQuality.HANDMADE) {
                newProperties.p_brand = ['HANDMADE'];
            }

            const isServicesCat = isServicesCategory(category.name);
            if (isServicesCat) {
                newProperties.quality = [ProductQuality.SERVICES];
            } else if (properties.quality?.[0] === ProductQuality.SERVICES) {
                newProperties.quality = [];
            }

            const isJobsCat = isJobsCategory(category.name);
            if (isJobsCat) {
                newProperties.quality = [ProductQuality.JOBS];

                if (category.name === 'work_abroad') {
                    change('location', '0');
                }
            }

            change('properties', newProperties);
            if (isMobile) {
                onCloseFormPage();
            } else {
                this.onModalClose();
            }
        }
    };

    private renderPhotos = ({
        value,
    }: {
        value: Array<PendingPhotoUpload | SuccessfulPhotoUpload | FailedPhotoUpload>;
    }) =>
        value && value.length ? (
            <div className={styles.ProductCreateEditForm__photos}>
                <div className={styles.ProductCreateEditForm__photos__star}>
                    <FontAwesomeIcon icon={faStar} inverse className={styles.PhotoPreview__star__icon} />
                </div>

                <div className={styles.ProductCreateEditForm__photos__container}>
                    {value.map((upload) => (
                        <PhotoPreview
                            className={styles.ProductCreateEditForm__photos__photo}
                            key={upload.id}
                            upload={upload}
                            previewPhotoSize="s170x170"
                            showPhotoCode={false}
                            size={50}
                        />
                    ))}

                    <div
                        className={styles.ProductCreateEditForm__photos__mask}
                    />
                </div>
            </div>
        ) : null;

    private renderCategory = ({ value }: { value: string }) => <span>{value ? getLabel(value) : null}</span>;

    private renderQuality = ({ value }: { value: string[] }) =>
        value && value.length ? qualityLabels[value[0]] : null;

    private renderProperty = ({ value, input }: { value: string[]; input: WrappedFieldInputProps }) => {
        if (!value || !value.length) {
            return null;
        }

        const { category } = this.props;
        const facetKey = input.name.replace('properties.', '');
        const raw = bzProps[category][facetKey];

        const propValues = raw.reduce((acc, cur) => {
            acc[cur[0]] = cur[1];
            return acc;
        }, {});

        const ret = value.map((key) => [key, propValues[key]]);

        return (
            <span>
                {ret.map(([key, label], index) => (
                    <React.Fragment key={key}>
                        <PropertyValue value={key} label={label} property={facetKey} />
                        {index + 1 < ret.length && ', '}
                    </React.Fragment>
                ))}
            </span>
        );
    };

    private isPropertyEditDisabled = (property: string) => {
        const { initialValues, isAdminEdit, isModeratorEdit, correctedFields, category } = this.props;
        const initVal = property === 'category' ? initialValues.category : initialValues.properties[property];
        return (
            (correctedFields &&
                correctedFields.includes(property) &&
                initVal &&
                initVal.length > 0 &&
                !isModeratorEdit &&
                !isAdminEdit) ||
            (property === 'quality' && getParentCategory(category)?.name === 'services')
        );
    };

    private onLocationChange = () => {
        const { change, untouch } = this.props;
        change('place', '');
        untouch('place');
    };
}

const photosConfig: PhotosUploadConfig = {
    photoType: 'product',
    multiple: true,
    showPhotoCode: false,
    previewPhotoSize: 's460xn',
    previewSize: 150,
    dragPreviewPhotoSize: 'snx80',
    previewNoCrop: true,
    showMainPhoto: true,
    uploadScreenInfo: (
        <div className={styles.ProductCreateEditForm__uploadScreenInfo}>
            <Interpolate
                i18nKey={PRODUCT_CREATE_EDIT_FORM_UPLOAD_SCREEN_INFO_icon}
                icon={
                    <span className={cx('fa-layers fa-fw', styles.ProductCreateEditForm__star)}>
                        <FontAwesomeIcon icon={faCircle} className={styles.ProductCreateEditForm__star__background} />
                        <FontAwesomeIcon icon={faStar} inverse transform="shrink-6" />
                    </span>
                }
            />
        </div>
    ),
    autoDialogOpen: AutoDialogOpenType.IF_NO_PHOTOS,
};

export const formSelector = formValueSelector(PRODUCT_CREATE_EDIT_FORM_NAME);
function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const photos = formSelector(state, 'photos');
    const formState = getFormState(state, PRODUCT_CREATE_EDIT_FORM_NAME);
    const category = formSelector(state, 'category');
    const isJobsCat = isJobsCategory(category);
    const isWorkAbroad = category === 'work_abroad';

    return {
        // Prevent re-rendering when user is typing to title field which is displayed on Main page
        title: formState.currentFormPage === FormPageType.Main ? null : formSelector(state, 'title'),
        // Prevent re-rendering when photos are changing on Photos page
        mainPhoto:
            formState.currentFormPage !== FormPageType.Photos &&
            photos &&
            photos.length &&
            photos[0].status === PhotoUploadStatus.SUCCESS
                ? photos[0]
                : null,
        location: isWorkAbroad ? '0' : ownProps.locationRequired || isJobsCat ? formSelector(state, 'location') : null,
        category,
        properties: formSelector(state, 'properties'),
    };
}

const ConnectedProductCreatedEditForm = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    undefined,
)(ProductCreateEditForm);

export default mkReduxForm<ProductFormData, OwnProps>({
    formName: PRODUCT_CREATE_EDIT_FORM_NAME,
    onValidate: (values, props) => ProductCreateEditForm.validate(values, props),
    onSave: (values, props) => props.onSave(values),
    photosConfig: (props) => ({
        ...photosConfig,
        disableCancel: props.isModeratorEdit,
        disableUpload: props.isModeratorEdit,
    }),
})(ConnectedProductCreatedEditForm);
